module.exports = __webpack_public_path__ + "img/slide5.e934bbe4.png";